export function normalizeAxiosError (error) {
    const response = error ? error.response : null
    const config = response ? response.config : (error && error.config) || {}
    if (!response) {
        return {
            message: (error && error.message) || '请求超时，请重试',
            code: 500,
            src: config.url
        }
    }

    const data = response.data
    const responseMessage = data && (data.msg || data.message)
    return {
        message: typeof data === 'string'
            ? data
            : responseMessage || response.statusText || '请求失败',
        code: response.status,
        src: config.url
    }
}
